<template>
  <el-tabs v-model="tabsName" @tab-click="gotoOtherPage">
    <el-tab-pane v-for="(item,index) in list" :key="index" :label="item.name" :name="item.name">
    </el-tab-pane>
  </el-tabs>
</template>

<script type="text/ecmascript-6">
import { tool } from "../common/js/tool.js";
export default {
  data() {
    return {
      tabsName: "",
      list: [
        { name: "人员信息报表", url: "/data/person-info" },
        { name: "人员分布报表", url: "/data/pi1-person-distribution" },
        { name: "轨迹报表", url: "/data/pi2-person-track" },
        { name: "出入统计", url: "/data/pi3-in-out" },
        { name: "人员报警记录", url: "/data/pi4-person-warning" },
        { name: "滞留人员清单", url: "/data/pi5-person-retention" },
        { name: "工种人数统计", url: "/data/pi6-work-type" },
        { name: "部门人数汇总", url: "/data/pi7-department-count" }
      ]
    };
  },

  props: ["name"],

  computed: {},

  created() {},

  updated() {
    this.tabsName = this.name;
  },

  methods: {
    gotoOtherPage() {
      // let hash = window.location.hash.replace("#", "");
      let hash = this.$route.query.u;
      for (let i = 0; i < this.list.length; i++) {
        if (this.tabsName == this.list[i].name) {
          this.$router.push({
            path: this.list[i].url,
            query: { u: "/data/person-info" }
          });
          // if (this.list[i].url !== hash) {
          //   this.$router.push({
          //     path: this.list[i].url,
          //     query: { u: "/data/person-info" }
          //   });
          // } else {
          //   // return;
          // }
          break;
        }
      }
    }
  },

  components: {}
};
</script>

<style lang="less" rel="stylesheet/less">
@import "../common/less/variable.less";
</style>
